var UpgradeHeader = require("components/users/teachers/upgrade/UpgradeHeader");
var UpgradeForm = require("components/users/teachers/upgrade/UpgradeForm");
var CurrentUser = require("lib/account/CurrentUser");
var LiveChatClient = require("lib/integrations/LiveChatClient");

class UpgradePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getPlan() {
		return $wr.getURLParameterByName("plan");
	}
	getPeriod() {
		return $wr.getURLParameterByName("period") || "year";
	}
	getClassCount() {
		return parseInt($wr.getURLParameterByName("class_count")) || 1;
	}

	afterUpgrade() {
		CurrentUser.fetchCurrentUserData(() => {
			$wr.redirect('/');
		});
	}

	render() {
		var plan = this.getPlan();

		return (
			<div className="upgradePage">
				<UpgradeHeader product={ plan }
					showSkipOption={ CurrentUser.get().pending_onboarding } />
				<UpgradeForm product={ plan } period={ this.getPeriod() }
					classCount={this.getClassCount()} afterUpgrade={ this.afterUpgrade } />
			</div>
		);
	}

	componentDidMount() {
		LiveChatClient.init(CurrentUser.get())

		// temporarily make view mobile-responsive
		var metaTag = document.createElement("meta");
		metaTag.name = "viewport"
		metaTag.id = "tempViewportElement"
		metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
		document.getElementsByTagName('head')[0].appendChild(metaTag);
	}
	componentWillUnmount() {
		// remove mobile-responsive metatag
		var metaTag = document.getElementById("tempViewportElement");
		metaTag.content = "width=970"
	}
};

UpgradePage.propTypes = PageStrictPropTypes({
});

module.exports = UpgradePage;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/upgrade/UpgradePage.js